export enum ProductsNumbers {
    CAR = '1001',
    VILLA = '2005',
    HEM = '2002',
    ACCIDENT = '3006',
    EMPLOYEE_HEALTHCARE = '3005',
    COMPANY_CAR = '4003',
    MOTORCYCLE = '1008'
}

export default ProductsNumbers;
